import ClosedSymbol from './ClosedSymbol';

export default ClosedSymbol;